import React from "react";
import ErrorIcon from "material-ui/svg-icons/alert/error";

const BANNER_STYLE = {
  padding: 10,
  borderRadius: 10,
  padding: "5px 9px",
  border: "1px solid #ffeb3b",
  backgroundColor: "#fff8bd",
  display: "flex",
  alignItems: "center"
};

const ICON_STYLE = {
  height: 20,
  verticalAlign: "-5px",
  width: 20,
  minWidth: 20,
  marginRight: 5,
  color: "#f9a825"
};

export default ({ type, style }) => {
  return (
    <div style={Object.assign({}, BANNER_STYLE, style)}>
      <ErrorIcon style={ICON_STYLE} />
      <div>
        <strong>This {type} is synchronized from Eventival.</strong> Any changes
        made in Eventival will update the {type}.
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/eventival-banner.jsx